<div class="h-100">
  <finxone-web-frontend-international-currency-country
    class="h-100"
    [showCurrencyFlags]="showCurrencyFlags"
    [currencyCodes]="currenciesCodes"
    [countryList]="countryList"
    [customStyle]="contentStyle"
    [widgetConfig]="widgetConfig"
    [currentInactiveStyle]="currentStyle"
    [currentActiveStyle]="currentActiveStyle"
    [isSubmitTypeAsynchronous]="true"
    (FormChangeEvent)="updateFormActionState($event)"
  >
  </finxone-web-frontend-international-currency-country>
</div>
